import Items from './form-items.svelte'
import Item from './form-item.svelte'
import Buttons from './form-buttons.svelte'
import Button from '@components/buttons/button.svelte'
import DeleteButton from '@components/buttons/delete-button.svelte'
import Label from './form-label.svelte'
import Section from './form-section.svelte'
import Fieldset from './form-fieldset.svelte'
import ErrorMessage from './error-message.svelte'
import Element from './element.svelte'
import Submit from './submit.svelte'

const Form = {
  Items,
  Item,
  Buttons,
  Label,
  Section,
  Fieldset,
  Button,
  DeleteButton,
  ErrorMessage,
  Element,
  Submit
}

export default Form